module.exports = __webpack_public_path__ + "static/tabaxi-AYAGWW-62abd573a8d5cc8cf8ea9066af9ba187.png";